import $ from "jquery";
import PerfectScrollbar from 'perfect-scrollbar';

// -------------------------------------------------------------------------- //
//
// -------------------------------------------------------------------------- //

var refreshHeaderNav = function() {
    $('#header .header-navigation-inner').height($(window).width() < 1199 ? ($(window).height() - $('#header').height()) : 'auto');
};

$('.header-navigation-toggle').on('click', function() {
    refreshHeaderNav();
    $('#header').toggleClass('toggled');
});

$('.header-navigation a, .header-navigation .btn').on('click', function() {
    refreshHeaderNav();
    $('#header').removeClass('toggled');
});

// -------------------------------------------------------------------------- //
//
// -------------------------------------------------------------------------- //

var videos = [];

$('[data-toggle-video]').on('click', function(e) {

    var videoId = $(this).data('toggle-video');

    e.preventDefault();

    for (var i = 0; i < videos.length; i++)
    {
        if (videoId === videos[i].id)
        {
            videos[i].player.play();
            return;
        }
    }

    var container = $('<div class="wistia_embed wistia_async_' + videoId + ' popover=true"></div>');

    $('body').append(container);

    setTimeout(function() {

        var player = Wistia.api(videoId);

        if (player)
        {
            videos.push({
                id          : videoId,
                player      : player,
                container   : container
            });

            player.play();
        }

    }, 10);
});

// -------------------------------------------------------------------------- //
//
// -------------------------------------------------------------------------- //

var globalRefreshTimeout = 0;

window.globalRefresh = function()
{
    var scrollTop = $(window).scrollTop();
    $('body')[scrollTop > 0 ? 'addClass' : 'removeClass']('scrolled');
    refreshHeaderNav();

    if ($(window).width() < 1200)
    {
        var bgHeight = $('#screen-2 .left-panel').offset().top + $('#screen-2 .left-panel').outerHeight();
        $('#screen-2 .screen-bg').height(bgHeight);
    }
    else
    {
        $('#screen-2 .screen-bg').height('auto');
    }

    if ($('body').hasClass('comparison-table-active'))
    {
        $(window).scrollTop(0);
    }

    clearTimeout(globalRefreshTimeout);

    globalRefreshTimeout = setTimeout(function() {
        refreshHeaderNav();
    }, 300);
}

/*$('#screen-2 .screen-inner').on('scroll', function() {
    var scrollTop = $('#screen-2 .screen-inner').scrollTop();
    $('body')[scrollTop > 0 ? 'addClass' : 'removeClass']('scrolled scrolled-inner');
});*/

$(window).on('scroll resize', function() {
    globalRefresh();
});

window.globalRefresh();

// -------------------------------------------------------------------------- //
//
// -------------------------------------------------------------------------- //

$('.comparison-table').on('scroll', function() {
    var scrollTop = $('.comparison-table').scrollTop();
    $('body')[scrollTop > 0 ? 'addClass' : 'removeClass']('scrolled-inner');
});



// -------------------------------------------------------------------------- //
//
// -------------------------------------------------------------------------- //

var refreshSidePanels = function() {

    $('.side-panel .side-panel-container-inner > div:first-child > div > div').each(function() {

        if ($(window).width() >= 1200)
        {
            if (!this.ps)
            {
                this.ps = new PerfectScrollbar(this, {
                    suppressScrollX: true
                });
            }

            $(this).height($(this).closest('.side-panel').height());
        }
        else
        {
            $(this).height('auto');

            if (this.ps)
            {
                this.ps.destroy();
                this.ps = null;
            }
        }
    });
};

$('.side-panel .side-panel-container-inner').on('scroll', function() {

    var navigation = $(this).find('.side-panel-navigation');

    if (navigation.length > 0 && $(window).width() < 1200 && navigation.offset().top - $(window).scrollTop() <= 0)
    {
        navigation.addClass('sticky');
    }
    else
    {
        navigation.removeClass('sticky');
    }
});

$(window).on('resize', function() {
    refreshSidePanels();
});

refreshSidePanels();


$('.mlink').on('click', function() {

    if (window.Munchkin)
    {
        console.log('Munchkin:', 'clickLink', location.pathname + '#' + $(this).data('desc'));

        window.Munchkin.munchkinFunction('clickLink', {
            'href': location.pathname + '#' + $(this).data('desc')
        });
    }
});
